export enum IntegrationTypeModel {
  CALCOM = "calcom",
  GHL = "ghl",
}
